// Master soft-limiter preventing digital clipping when 4 stems sum at full gain.
export function createLimiter(ctx: AudioContext): DynamicsCompressorNode {
  const node = ctx.createDynamicsCompressor();
  node.threshold.value = -3;
  node.knee.value = 6;
  node.ratio.value = 4;
  node.attack.value = 0.003;
  node.release.value = 0.1;
  return node;
}
